import type { Lesson } from '../../schema.js';

export const MATE_IN_ONE_LESSONS: Lesson[] = [
  {
    id: 'puzzle-mate-in-1',
    slug: 'puzzles-mate-in-1',
    title: 'Mate in one',
    audienceLevel: 'beginner',
    concepts: ['puzzles'],
    steps: [
      {
        kind: 'explain',
        title: 'Deliver the final check',
        body: 'Checkmate ends the game. In these puzzles it is your turn and the enemy king has only one weakness left. Find the check that gives checkmate.',
        narration: 'Find the checkmate in one move.',
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Back rank mate',
        body: 'Mate the black king in one move.',
        fen: '7k/4Q3/6K1/8/8/8/8/8 w - - 0 1',
        answer: ['Qd8#', 'Qe8#', 'Qf8#', 'Qg7#', 'Qh7#'],
        solution: ['Qe8#'],
        expect: 'mate',
        tier: 1,
        hint: 'Find a check that ends the game.',
        hintLadder: ['Find a check that ends the game.', 'Your queen can mate on the 8th rank.', 'Try Qe8#.'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Trapped by pawns',
        body: 'The black king is hemmed in by its own pawns. Mate it with your rook.',
        fen: '6k1/5ppp/8/8/8/8/8/R5K1 w - - 0 1',
        answer: ['Ra8#'],
        solution: ['Ra8#'],
        expect: 'mate',
        tier: 1,
        hint: 'The king cannot escape through its own pawns.',
        hintLadder: ['The king cannot escape through its own pawns.', 'Move your rook to the 8th rank.', 'Ra8 is checkmate!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Rook and king',
        body: 'Your rook and king work together. Mate the black king in one move.',
        fen: '6k1/5ppp/8/8/8/8/8/4R1K1 w - - 0 1',
        answer: ['Re8#'],
        solution: ['Re8#'],
        expect: 'mate',
        tier: 1,
        hint: 'Put your rook on the same row as the king.',
        hintLadder: ['Put your rook on the same row as the king.', 'Your king guards the escape squares.', 'Re8 is checkmate!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Queen on the file',
        body: 'Your queen can mate from far away. Find the move.',
        fen: '7k/5Q2/6K1/8/8/8/8/8 w - - 0 1',
        answer: ['Qe8#', 'Qf8#', 'Qg7#', 'Qh7#'],
        solution: ['Qf8#'],
        expect: 'mate',
        tier: 2,
        hint: 'The king has very few escape squares.',
        hintLadder: ['The king has very few escape squares.', 'Your queen controls the 8th rank and the g-file.', 'Qf8 is checkmate!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'From the corner',
        body: 'A quiet queen works too. Mate the king in one move.',
        fen: '7k/8/7K/8/8/8/8/6Q1 w - - 0 1',
        answer: ['Qg7#'],
        solution: ['Qg7#'],
        expect: 'mate',
        tier: 2,
        hint: 'Your king covers the escape squares.',
        hintLadder: ['Your king covers the escape squares.', 'The queen slides in front of the king.', 'Qg7 is checkmate!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Pawn support',
        body: 'Your pawn helps the queen. Mate the king in one move.',
        fen: '7k/5Q2/6PK/8/8/8/8/8 w - - 0 1',
        answer: ['Qe8#', 'Qf8#', 'Qg7#', 'Qh7#', 'g7#'],
        solution: ['Qf8#'],
        expect: 'mate',
        tier: 2,
        hint: 'Your pawn guards g7 and h8.',
        hintLadder: ['Your pawn guards g7 and h8.', 'The king is squeezed on the back rank.', 'Qf8 is checkmate!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Capture first',
        body: 'Sometimes you must capture a defender before mating. Find the move.',
        fen: '7k/5Qp1/6K1/8/8/8/8/8 w - - 0 1',
        answer: ['Qe8#', 'Qf8#', 'Qxg7#'],
        solution: ['Qxg7#'],
        expect: 'mate',
        tier: 3,
        hint: 'A black pawn guards one escape square.',
        hintLadder: ['A black pawn guards one escape square.', 'Capture the pawn and mate in the same move.', 'Qxg7 is checkmate!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Down the open file',
        body: 'Your queen travels down the e-file. Mate the king in one move.',
        fen: '6k1/5ppp/8/8/8/8/4Q3/6K1 w - - 0 1',
        answer: ['Qe8#'],
        solution: ['Qe8#'],
        expect: 'mate',
        tier: 3,
        hint: 'The king is stuck behind its pawns.',
        hintLadder: ['The king is stuck behind its pawns.', 'The e-file is wide open to the 8th rank.', 'Qe8 is checkmate!'],
      },
    ],
  },
];
